import './styles.scss'

import React, { useEffect, useState } from 'react'
import { useValues } from 'kea'
import ReactHtmlParser from 'react-html-parser'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

import bookmarkIcon from '../_assets/bookmark-icon.svg'
import noTagsIcon from '../_assets/no-tags-icon.svg'

import courseShowLogic from '~/scenes/course/show/logic'

const MAX_SHOW_SUBTAGS = 20

const Subcategory = ({ id: skillId, title: skillTitle, url: skillUrl, tags, isExpanded, onToggleExpand }) => {
  const { isDesktop } = useValues(courseShowLogic)

  const [isDesktopBreakpoint, setIsDesktopBreakpoint] = useState(false)

  useEffect(() => {
    setIsDesktopBreakpoint(isDesktop)
  }, [isDesktop])

  const areTagsExisting = tags.length > 0
  let someSkillsAreaExceedMax

  if (typeof window !== 'undefined') {
    const threshold = isDesktopBreakpoint ? 76 : 117
    someSkillsAreaExceedMax = Array.from(window.document.querySelectorAll(`#${skillId} .skill-tags`)).some(
      tagsArea => tagsArea.scrollHeight > threshold
    )
  }

  const emptyTitleTags = tags.filter(tag => !tag.title.trim())
  const nonEmptyTitleTags = tags.filter(tag => tag.title.trim())

  const allTags = [
    ...emptyTitleTags.flatMap(tag => tag.subtags.slice(0, MAX_SHOW_SUBTAGS).map(subtag => ({ text: subtag }))),
    ...nonEmptyTitleTags.flatMap(tag => [
      { masterTagTitle: true, text: `${tag.title}:` },
      ...tag.subtags.slice(0, MAX_SHOW_SUBTAGS).map(subtag => ({ text: subtag }))
    ])
  ]

  return (
    <div
      key={skillId}
      id={skillId}
      className={`skill-card${areTagsExisting ? ' with-tags' : ' without-tags'}${isExpanded ? ' full' : ''}`}
    >
      <div className='skill-title-icon-container'>
        <div className='skill-icon-container'>
          <img className='skill-icon' alt='skill icon' src={bookmarkIcon} width={10} height={15} />
        </div>
        <a className='skill-title' href={skillUrl}>
          {skillTitle}
        </a>
      </div>
      <div className='skill-content-container'>
        {areTagsExisting ? (
          <div className='skill-tags'>
            {allTags.map(item => (
              <div className={`skill-tag ${item.masterTagTitle ? 'master-tag' : ''}`}>
                <div className='skill-text'>{item.text}</div>
              </div>
            ))}
          </div>
        ) : (
          <div className='empty-tags-container' />
        )}
      </div>

      {areTagsExisting && someSkillsAreaExceedMax && (
        <div className='show-more-container' onClick={() => onToggleExpand(skillId)}>
          <div className='text'>{isExpanded ? I18n.t('courses.show.show_less') : I18n.t('courses.show.show_more')}</div>
          <div className='icon'>
            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24'>
              <g id='arrow_right_icon' data-name='arrow right icon' transform='translate(4407.5 2116.5)'>
                <path
                  id='Path_7728'
                  data-name='Path 7728'
                  d='M0,0H24V24H0Z'
                  transform='translate(-4407.5 -2116.5)'
                  fill='none'
                />
                <path
                  id='Path_7730'
                  data-name='Path 7730'
                  d='M-9310.039-6661.806l6.481,6.481-6.481,6.481'
                  transform='translate(4910.539 4550.306)'
                  fill='none'
                  stroke='#6a6a6a'
                  strokeWidth='2'
                />
              </g>
            </svg>
          </div>
        </div>
      )}
    </div>
  )
}

const Skills = ({ skills }) => {
  const [expandedSkillId, setExpandedSkillId] = useState(null)

  const handleToggleExpand = skillId => {
    setExpandedSkillId(expandedSkillId === skillId ? null : skillId)
  }

  const sortedSkills = skills => {
    return skills.sort((firstSkill, secondSkill) => {
      const firstSkillHasTags = firstSkill.tags && firstSkill.tags.length > 0
      const secondSkillHasTags = secondSkill.tags && secondSkill.tags.length > 0

      if (firstSkillHasTags && !secondSkillHasTags) return -1
      if (secondSkillHasTags && !firstSkillHasTags) return 1

      return 0
    })
  }

  return (
    <div className='skills-section'>
      <div className='skill-title'>{I18n.t('courses.show.skills').slice(0, -1)}</div>
      <div className='skill-cards-container'>
        {sortedSkills(skills).map(subCategory => (
          <Subcategory
            key={subCategory.id}
            isExpanded={expandedSkillId === subCategory.id}
            onToggleExpand={handleToggleExpand}
            {...subCategory}
          />
        ))}
      </div>
    </div>
  )
}

Skills.propTypes = {
  skills: PropTypes.array
}

Subcategory.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  tags: PropTypes.array,
  isOtherTagsPresent: PropTypes.bool,
  isExpanded: PropTypes.bool,
  onToggleExpand: PropTypes.func
}

export default Skills
